import React from "react";

import useSmoothScrollWithOffset from "../useSmoothScrollWithOffset";

export const Careerplus = (props) => {
    useSmoothScrollWithOffset(80);
    return (
      <div id="careerplus">
        <h1>Coming Soon...</h1>
        </div>
    );
    }
